// @flow
import React from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import * as themes from 'Browser/themes';

import configureFela from 'Browser/configureFela';
import configureStore from 'Common/configureStore';
import common from 'Common/app/common';
import CastReceiver from 'Browser/cast/receiver/CastReceiver';
import BaseRoot from 'Browser/app/BaseRoot';
import reducer from 'found/lib/foundReducer';

import './App.css';
import { initialState } from './initialState';
import './vendor';

const store = configureStore({ initialState, platformReducers: { found: reducer } });
const Root = common({ themes })(({ children }) => children);

class App extends React.Component {
  componentDidMount() {
    this.appendNielsen();

    if (process.env.IN_DEBUG) window.reload = () => window.location.reload();
  }

  render() {
    const felaRenderer = configureFela();

    return (
      <Router>
        <Helmet
          meta={[
            {
              name: 'viewport',
              content: 'width=device-width, initial-scale=1, shrink-to-fit=no',
            },
            { 'http-equiv': 'x-ua-compatible', content: 'ie=edge' },
            {
              content: 'upgrade-insecure-requests',
              'http-equiv': 'Content-Security-Policy',
            },
          ]}
        />
        <BaseRoot store={store} felaRenderer={felaRenderer}>
          <Root>
            <div className="App">
              <header className="App-header">
                <CastReceiver />
              </header>
            </div>
          </Root>
        </BaseRoot>
      </Router>
    );
  }

  /**
    This methods appends nielsen analytics scripts exactly the way src/dany-one/src/server/frontend/render.js does it.
    NOTE: config/webpack.config.js exposes nielsen related configuration ((process.env.nielsen) via webpack.DefinePlugin.
   */
  appendNielsen() {
    const nielsenAnalyticsSrc = ` !function(t,n)
{
  t[n]=t[n]||
  {
    nlsQ:function(e,o,c,r,s,i)
    {
     return s=t.document,
     r=s.createElement("script"),
     r.async=1,
     r.src=("http:"===t.location.protocol?"http:":"https:")+"//cdn-gl.imrworldwide.com/conf/"+e+".js#name="+o+"&ns="+n,
     i=s.getElementsByTagName("script")[0],
     i.parentNode.insertBefore(r,i),
     t[n][o]=t[n][o]||{g:c||{},
     ggPM:function(e,c,r,s,i){(t[n][o].q=t[n][o].q||[]).push([e,c,r,s,i])}},t[n][o]
    }
  }
}
(window,"NOLBUNDLE");

  var nSdkDebug = ('${process.env.IN_DEBUG && process.env.nielsen.nol_sdkDebug}' ? 'warn' : '');
  var nSdkInstance = NOLBUNDLE.nlsQ("${process.env.nielsen.apid}", "DanyHtml5", {
  nol_sdkDebug: nSdkDebug,
  optout: "false"
});
`;

    const nielsenScript = document.createElement('script');
    nielsenScript.type = 'text/javascript';
    nielsenScript.innerHTML = nielsenAnalyticsSrc;
    document.getElementsByTagName('head')[0].append(nielsenScript);
  }
}
export default App;

/*
  FIXME:
   - reset media element on ERROR - otherwise it fail playback from idle after moving from ERROR state
   - player ui doesn't re-connects when changing source
   - ignore remote seek for DVR
   - fail to load media after sling error (at master)
   - ignore ALL requests when loading, seeking, initialing Austin (hook it on state machine state)
   - BM doesn't hide ui after SEEK request
   - send poster for Austin Live channels
   - stop cast session when closing player
   - close when receiver disconnects
   - read .yaml fields (do we need this?)
   - reset seek when changing source (sender)
   - if playing sling live and starting cast - it start casting last OD / purchase
   - what if sling cast is started via mobile? (middleware sends LoadRequest in that case which may break austin media element)
   - seek to pos where cast started doesn't work

    - seek via remote kills playback
   - if (payload.auth?.signInType) payload.auth.signInType = 'none'; - sign outs the app every time - check if its fine
   - sync austinJS and bitmovin version with danyOne
   - Send status to every connected sender (because receiver have to know if receiver already plays austin)

  Later:
   - integrate bugsnag to receiver
   - Extra attributes from the server: style
   - set initial volume
   - handle logout cases
   - mobile looses content details after LL stitching (e.g. doesn't display controls)
   - think about that events(https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Media_events)
   - remove source maps in prod builds

  FIXME:
  - handle config in webpack somehow (int, qa, prod)
  - refactor initialState.js file
  - add reading of all .yaml files to the bootstrap process
  - let reducers init initial state automatically

  Austin issues (3.0.34):
    - it ignores loglevel config
    - it doesn't dispatch on_play event

  - fix CORS for https://qarelay.sling.com
  - crashes when pass video element (play func) cyclic deps (when it tries to copy via JSON.stringify and JSON.parse)
  - docs for log level      *     platform: 'web',
                          *     log: {level: 'debug'}
  - playerContainerId: BITMOVIN_PLAYER_CONTAINER_ID, // FIXME: post that bug - Austin doesn't use this param and report it as absent
*/
